import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from './request.service';

@Injectable({
	providedIn: 'root'
})

export class UserActivationService {

	constructor(
		private _http: RequestService) {
	}

	requestPasswordReset(email: string): Observable<any> {
		return this._http.put(`/accounts/challenge/password-reset`, '', { email: email })
	}

	validateActivationRequest(emailKey: string, fp: string): Observable<any> {
		return this._http.put(`/accounts/validate`, '', { emailKeyValidation: emailKey, fingerprint: fp })
	}

	validateResetActivationRequest(emailKey: string, fp: string): Observable<any> {
		return this._http.put(`/accounts/validate-reset`, '', { emailKeyValidation: emailKey, fingerprint: fp })
	}

	putPasswordReset(id: string, password: string): Observable<any> {
		return this._http.put(`/accounts/password-reset`, '', { id: id, password: password })
	}

	putPassword(id: string, password: string): Observable<any> {
		return this._http.put(`/accounts/password`, '', { id: id, password: password })
	}

}